<template>
  <b-container
    fluid
  >
    <b-row class="mb-4">
      <b-col
        cols="12"
      >
        <b-card
          title="Total Transactions"
          class="shadow-sm"
        >
          <b-row>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="3"
              order-md="4"
            >
              <PaleCard
                label="QR Ph"
                variant="success"
                :count="reports.qrph"
                :link="{ name: 'user.reports.qrph' }"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="4"
              order-md="5"
            >
              <PaleCard
                label="GCash"
                variant="primary"
                :count="reports.gcash"
                :link="{ name: 'user.reports.gcash' }"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="5"
              order-md="6"
            >
              <PaleCard
                label="Swift Pay"
                variant="warning"
                :count="reports.swiftpay"
                :link="{ name: 'user.reports.swiftpay' }"
                :loading="fetching"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import PaleCard from '@/components/custom/PaleCard'

export default {

  name: 'MechantDashboard',

  middleware: ['auth', 'merchant'],

  components: {
    PaleCard
  },

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: false,
      reports: {
        qrph: 0,
        gcash: 0,
        swiftpay: 0
      }
    }
  },

  mounted () {
    core.index()
  }
}
</script>
